import { render, staticRenderFns } from "./NumberPerson.vue?vue&type=template&id=464a1c04&scoped=true"
import script from "./NumberPerson.vue?vue&type=script&lang=js"
export * from "./NumberPerson.vue?vue&type=script&lang=js"
import style0 from "./NumberPerson.vue?vue&type=style&index=0&id=464a1c04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a1c04",
  null
  
)

export default component.exports